import { regexps } from '../../shared/utils/regex';
export const getQuestions = () => [
  {
    name: 'yourDetails',
    label: 'consent.form.details',
    step: 1,
    col: 1,
    isDisabled: true,
    hideLabel: true,
    type: 'title',
    value: 'title',
  },
  {
    name: 'firstName',
    label: 'identification.firstName',
    type: 'inputText',
    step: 1,
    col: 1,
    isDisabled: true,
  },
  {
    name: 'lastName',
    label: 'identification.lastName',
    type: 'inputText',
    step: 1,
    col: 1,
    isDisabled: true,
  },
    {
    name: 'email',
    label: 'consent.user.email',
    type: 'inputText',
    pattern: regexps.email,
    step: 1,
    col: 1,
    isDisabled: true,
  },
  {
    name: 'ppsn',
    label: 'consent.form.ppsn',
    type: 'inputText',
    step: 1,
    col: 1,
    isDisabled: true,
  },
  {
    name: 'birthDate',
    label: 'identification.dateOfBirth',
    type: 'calendar',
    options: {
      minDate: new Date(1900, 0, 1),
    },
    step: 1,
    col: 1,
    isDisabled: true,
  },
  {
    name: 'consent',
    label: 'consent.form.consent',
    type: 'checkbox',
    errorName: 'consent.form.consentL',
    hideLabel: true,
    step: 1,
  },
];
